<template>
  <div class="container-fluid p-0">
    <div class="container-fluid">
      <div class="fixed-content row dropdown d-flex w-100 align-items-center">
        <div class="col-auto tabs-container">
          <div class="text-center">
            <Tabs
              :items="itemTabs"
              :active="activeTab"
              path="/administrator/"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="row w-100 justify-content-end">
            <div class="col-auto d-flex">
              <button
                type="button"
                class="btnAdd btn"
                @click="handleDeviceModal"
              >
                + Add Device
              </button>
            </div>
            <div class="col-auto d-flex">
              <!-- @click="handleAddModal" -->
              <button
                type="button"
                class="btn btn-outline-success"
                @click="handleImportModal"
              >
                Import CSV
              </button>
            </div>
            <div class="form-group w-auto position-relative">
              <input
                class="form-control btn-search"
                type="text"
                required=""
                placeholder="Search records"
                v-model="search"
              />
              <i class="icofont icofont-search-alt-2"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 p-0">
          <div class="large-card position-relative custom-scrollbar">
            <div class="row g-4">
              <div class="col-12">
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :items="items"
                  :server-items-length="serverItemsLength"
                  :loading="loading"
                  :headers="Headers"
                  :rows-items="rowItems"
                  buttons-pagination
                  table-class-name="customize-table"
                  rows-per-page-message=""
                  theme-color="#0492FF"
                  show-index-symbol="No."
                  show-index
                >
                  <template #item-index="{ index }">
                    <div class="number">
                      {{ index }}
                    </div>
                  </template>
                  <template #item-LastUpdated="{ LastUpdated }">
                    {{ dateFormat(LastUpdated, "DD / MM / YYYY, h:mm a") }}
                  </template>
                  <template #item-DateCreated="{ DateCreated }">
                    {{ dateFormat(DateCreated, "DD / MM / YYYY, h:mm a") }}
                  </template>

                  <template #item-edit="data"
                    ><button
                      @click="() => edit(data)"
                      class="btn-edit"
                      role="button"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                      >
                        <ellipse
                          cx="16.3178"
                          cy="16.5"
                          rx="16.3178"
                          ry="16.5"
                          fill="#BCEFDB"
                        />
                        <path
                          d="M7.37891 21.4624V24.5024C7.37891 24.7824 7.59891 25.0024 7.87891 25.0024H10.9189C11.0489 25.0024 11.1789 24.9524 11.2689 24.8524L22.1889 13.9424L18.4389 10.1924L7.52891 21.1024C7.42891 21.2024 7.37891 21.3224 7.37891 21.4624ZM25.0889 11.0424C25.1816 10.9499 25.2552 10.84 25.3053 10.7191C25.3555 10.5981 25.3813 10.4684 25.3813 10.3374C25.3813 10.2065 25.3555 10.0768 25.3053 9.95582C25.2552 9.83485 25.1816 9.72496 25.0889 9.63244L22.7489 7.29244C22.6564 7.19974 22.5465 7.12619 22.4255 7.07601C22.3046 7.02583 22.1749 7 22.0439 7C21.9129 7 21.7833 7.02583 21.6623 7.07601C21.5413 7.12619 21.4314 7.19974 21.3389 7.29244L19.5089 9.12244L23.2589 12.8724L25.0889 11.0424Z"
                          fill="#218863"
                        />
                      </svg>
                    </button>
                  </template>
                </EasyDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="addDeviceModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addDeviceModal"
      data-bs-backdrop="static"
      aria-hidden="true"
    >
      <AddDeviceModal
        @close-modal="isEdit = false"
        @on-save="handleSave"
        @on-delete="handleDelete"
        :isEdit="isEdit"
        :formEdit="formEdit"
        :flag="flag"
      />
    </div>
    <div
      class="modal fade"
      id="successModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="successModal"
      data-bs-backdrop="static"
      aria-hidden="true"
    >
      <SuccessModal
        :btnText="'Done'"
        :message="successMessage"
        :onSave="successSave"
      />
    </div>
    <div
      class="modal fade"
      id="warningModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="warningModal"
      data-bs-backdrop="static"
      aria-hidden="true"
    >
      <WarningModal
        :onSave="warningSave"
        :note="'This device will no longer be available if you agree to proceed.'"
      />
    </div>
  </div>
</template>
<script>
import { Modal } from "bootstrap";
import { mockServerItems } from "../data/administrator/deviceTable";
import Tabs from "../components/tabs/index.vue";
import moment from "moment";
import SuccessModal from "./uikits/modal/SuccessModal.vue";
import WarningModal from "./uikits/modal/WarningModal.vue";
import AddDeviceModal from "./uikits/modal/AddDeviceModal.vue";
import checkIcon from "@/assets/images/right.png";
import seruIcon from "@/assets/images/seru.png";

export default {
  data() {
    return {
      flag: "",
      search: "",
      filteredItems: [],
      temp: [],
      activeTab: "user",
      Headers: [
        {
          text: "Device Name",
          value: "DeviceName",
          sortable: false,
        },
        {
          text: "Type",
          value: "DeviceType",
          sortable: false,
        },
        {
          text: "Connection Type",
          value: "ConnectionType",
          sortable: false,
        },
        {
          text: "Description",
          value: "Description",
          sortable: false,
        },
        {
          text: "Date Created",
          value: "DateCreated",
          sortable: false,
        },
        {
          text: "Last Updated",
          value: "LastUpdated",
          sortable: false,
        },
        {
          text: "Edit",
          value: "edit",
          sortable: false,
        },
      ],
      itemTabs: [
        // {
        //   id: "administrator-tab-1",
        //   value: "user",
        //   label: "User",
        // },
        {
          id: "administrator-tab-2",
          value: "device",
          label: "Device",
        },
        {
          id: "administrator-tab-3",
          value: "gateway",
          label: "Gateway",
        },
        {
          id: "administrator-tab-4",
          value: "cluster",
          label: "Cluster",
        },
        {
          id: "administrator-tab-5",
          value: "feeder-pillar",
          label: "Feeder Pillar",
        },
      ],
      rowItems: [5, 10, 50, 100],
      items: [],
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 5,
      },
      loading: false,
      formEdit: {},
      isEdit: false,
      deviceModal: null,
      successModal: null,
      successMessage: "User successfully added",
      successSave: () => {},
      warningSave: () => {},
      warningModal: null,
    };
  },
  components: {
    Tabs,
    SuccessModal,
    WarningModal,
    AddDeviceModal,
  },
  computed: {
    restApiUrl() {
      const { page, rowsPerPage, sortBy, sortType } = this.serverOptions;
      // console.log(sortBy);
      // console.log(sortType);
      if (sortBy && sortType) {
        return `http://localhost:8080/api?page=${page}&limit=${rowsPerPage}&sortBy=${sortBy}&sortType=${sortType}`;
      } else {
        return `http://localhost:8080/api?page=${page}&limit=${rowsPerPage}`;
      }
    },
  },
  watch: {
    serverOptions() {
      // this.loadFromServer();
      this.getData();
    },
    search: {
      handler() {
        this.applyFilter(this.items);
      },
      immediate: false,
    },
  },
  created() {
    this.activeTab = "device";
  },
  mounted() {
    this.setHeaderComponent();

    this.deviceModal = new Modal(document.getElementById("addDeviceModal"), {});
    this.successModal = new Modal(document.getElementById("successModal"), {});
    this.warningModal = new Modal(document.getElementById("warningModal"), {});
    this.getData();
    // this.loadFromServer();
  },
  methods: {
    handleImportModal() {
      this.isEdit = false;
      this.flag = "import";
      this.deviceModal.show();
    },
    applyFilter(sourceItems) {
      const keyword = this.search.trim().toLowerCase();
      if (!keyword) {
        sourceItems = this.temp;
        this.filteredItems = sourceItems;
        // this.filteredItems = this.temp
      } else {
        this.filteredItems = sourceItems.filter((item) =>
          item.DeviceName.toLowerCase().includes(keyword)
        );
      }

      this.items = this.filteredItems;
      this.loadFromServer();
    },
    getData() {
      this.$http.get(":11005/api/v1/device").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);
          this.items = [];
          this.temp = [];
          for (var i = 0; i < response.length; i++) {
            let obj = {
              key: `${i}`,
              Application: response[i].AppID,
              DeviceProfileID: response[i].DeviceProfileID,
              DeviceEUI: response[i].Deveui,
              DeviceName: response[i].DeviceName,
              // DeviceDesc: response[i].DeviceDesc,
              DeviceType: response[i].DeviceType,
              DeviceTypeID: response[i].DeviceTypeID,
              ConnectionType: response[i].ConnType,
              ConnectionTypeID: response[i].ConnTypeID,
              DeviceBrand: response[i].DeviceBrand,
              DeviceModel: response[i].DeviceModel,
              Lantern: response[i].LanternID,
              FormFactor: response[i].FormFactorID,
              CommDate: response[i].CommDate,
              Latitude: response[i].Latitude,
              Longitude: response[i].Longitude,
              LoraAppKey: response[i].DeviceLoraAppKey,
              Description: response[i].DeviceDesc,
              DateCreated: response[i].CreatedAt,
              LastUpdated: response[i].UpdatedAt,
            };
            this.items.push(obj);
            this.temp.push(obj);
          }
          this.loadFromServer();
        }
      });
    },
    dateFormat(date, format = "DD/MM/YYYY") {
      if (date === "") return "";
      return moment(date).format(format);
    },
    async loadFromServer() {
      this.hidePaginationIndex();
      this.loading = true;
      // key: `${i}`,
      // DeviceName: "PPJ_STL_001_FP02",
      // DeviceType: "Streetlight NEMA Node",
      // ConnectionType: i === 2 ? "Cellular" : "LoraWAN",
      // Description: "Device",
      // DateCreated: "2024-09-17 10:45:00",
      // LastUpdated: "2024-09-17 10:45:00",pow
      // ConnectedCluster: "Cluster B",
      // LoraAppKey: "STL_01",
      // DeviceID: "STL_01",
      const { serverCurrentPageItems, serverTotalItemsLength } =
        await mockServerItems(this.serverOptions, this.items);
      this.items = serverCurrentPageItems;
      this.serverItemsLength = serverTotalItemsLength;
      // const response = await this.$http.get(":8001/api/v1/device", {params: this.serverOptions})
      // // console.log(response)
      // const serverCurrentPageItems = response.data.items;
      // this.items = serverCurrentPageItems;
      // this.serverItemsLength = serverTotalItemsLength;

      this.hidePaginationIndex();
      this.loading = false;
    },
    hidePaginationIndex() {
      const paginationIndex = document.querySelector(
        ".pagination__items-index"
      );
      const paginationRowInput = document.querySelector(".rows-input");
      if (!paginationIndex || !paginationRowInput) return;
      setTimeout(() => {
        paginationIndex.innerHTML = "";
        paginationRowInput.innerHTML = "View";
      }, 0);
    },
    edit(data) {
      // console.log(data);
      this.flag = "";
      this.formEdit = data;
      this.isEdit = true;
      this.deviceModal.show();
      // console.log(data);
    },
    handleDeviceModal() {
      this.flag = "";
      this.isEdit = false;
      this.deviceModal.show();
    },
    handleSave(e, devEUI) {
      // console.log(e)
      // console.log(this.isEdit)
      if (this.isEdit) {
        this.$http
          .put(":11005/api/v1/device/" + devEUI, e)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              // console.log(response);
              this.getData();
              this.$swal({
                title: `<div class="success-title"><img src="${checkIcon}" alt="check" /><p class="header">SUCCESSFUL!</p></div><p class="success-text">${response}</p>`,

                confirmButtonText: "Done",

                customClass: {
                  title: "swal2-content",
                  popup: "success-popup swal2-content",
                  confirmButton: "success-button",
                },
                buttonsStyling: false,
              });
              // this.successMessage = response;
              // this.successSave = () => this.successModal.hide();
              // this.successModal.show();

              this.deviceModal.hide();
            }
          })
          .catch((error) => {
            const message =
              error?.response?.data?.message ||
              "Something went wrong. Please try again.";

            this.$swal({
              title: `<div class="warning-title"><img src="${seruIcon}" alt="check" /><p class="header">WARNING!</p></div>`,
              html: `<p class="warning-subtitle">Note</p><p class="warning-subtitle2">${message}</p>`,
              // showCancelButton: true,
              confirmButtonText: "OK",
              // cancelButtonText: "No",
              customClass: {
                title: "swal2-content",
                popup: "warning-popup swal2-content",
                confirmButton: "warning-button",
                // cancelButton: "warning-cancel-button",
              },
              buttonsStyling: false,
            }).then((result) => {
              console.log(result);
            });
          });
      } else {
        // add device

        this.$http
          .post(":11005/api/v1/device", e)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              // console.log(response);
              this.getData();
              this.$swal({
                title: `<div class="success-title"><img src="${checkIcon}" alt="check" /><p class="header">SUCCESSFUL!</p></div><p class="success-text">${response}</p>`,

                confirmButtonText: "Done",

                customClass: {
                  title: "swal2-content",
                  popup: "success-popup swal2-content",
                  confirmButton: "success-button",
                },
                buttonsStyling: false,
              });
              // this.successMessage = response;
              // this.successSave = () => this.successModal.hide();
              // this.successModal.show();

              this.deviceModal.hide();
            }
          })
          .catch((error) => {
            const message =
              error?.response?.data?.message ||
              "Something went wrong. Please try again.";

            this.$swal({
              title: `<div class="warning-title"><img src="${seruIcon}" alt="check" /><p class="header">WARNING!</p></div>`,
              html: `<p class="warning-subtitle">Note</p><p class="warning-subtitle2">${message}</p>`,
              // showCancelButton: true,
              confirmButtonText: "OK",
              // cancelButtonText: "No",
              customClass: {
                title: "swal2-content",
                popup: "warning-popup swal2-content",
                confirmButton: "warning-button",
                // cancelButton: "warning-cancel-button",
              },
              buttonsStyling: false,
            }).then((result) => {
              console.log(result);
            });
          });
      }
      this.isEdit = false;
      // this.successModal.show();
    },
    handleDelete(e) {
      // console.log(e);

      this.$http
        .delete(":11005/api/v1/device/" + e)
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            this.$swal({
              title: `<div class="success-title"><img src="${checkIcon}" alt="check" /><p class="header">SUCCESSFUL!</p></div><p class="success-text">${response}</p>`,

              confirmButtonText: "Done",

              customClass: {
                title: "swal2-content",
                popup: "success-popup swal2-content",
                confirmButton: "success-button",
              },
              buttonsStyling: false,
            });
            // console.log(response);
            // this.successMessage = response;
            // this.successSave = () => this.successModal.hide();
            // this.successModal.show();
            this.getData();
            this.deviceModal.hide();
          }
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            "Something went wrong. Please try again.";

          this.$swal({
            title: `<div class="warning-title"><img src="${seruIcon}" alt="check" /><p class="header">WARNING!</p></div>`,
            html: `<p class="warning-subtitle">Note</p><p class="warning-subtitle2">${message}</p>`,
            // showCancelButton: true,
            confirmButtonText: "OK",
            // cancelButtonText: "No",
            customClass: {
              title: "swal2-content",
              popup: "warning-popup swal2-content",
              confirmButton: "warning-button",
              // cancelButton: "warning-cancel-button",
            },
            buttonsStyling: false,
          }).then((result) => {
            console.log(result);
          });
        });
    },
    setHeaderComponent() {
      this.$store.dispatch("common/setHeaderComponent", {
        title: "Administrator",
        subtitle: "",
        showBack: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-edit {
  display: flex;
  border: none;
  background: transparent;
  // border-radius: 50%;
}
.input-number-custom {
  width: 128px;
  height: 31px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid #eee;
  background: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  input {
    width: 40px;
    height: 20px;
    color: #000;
    text-align: center;
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border-radius: 3px;
    border: 1px solid #eee;
    background: #fff;
    padding: 0;
  }
  span {
    width: 31px;
    height: 31px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
.tabs-container {
  max-width: max-content;
}
.fixed-content {
  position: fixed;
  top: 114px;
  left: 112px;
  height: 51px;
  width: auto;
  z-index: 8;
}

.dropdown .dropdown-toggle {
  position: relative;
  width: 215px;
  padding: 0 15px;
  border-radius: 8px;
  border: none;
  background: #fff !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  color: #9b9a9a !important;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  &:hover {
    border: 1px solid #218863;
  }
  &::after {
    color: #218863;
    right: 15px;
  }
}
.large-card {
  height: calc(100vh - 63px - 167px);
  width: calc(100% + 22px);
  margin-top: 63px;
  margin-bottom: 23px;
  padding: 17px 0;
  padding-right: 10px;
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f5f6fa;
}

.small-card {
  height: 99px;
  img {
    width: 50px;
    height: 50px;
  }
  h2 {
    color: #000;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    margin-bottom: 6px;
  }
  h3 {
    color: #ababab;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
    margin-bottom: 3px;
  }
}
:deep(.customize-table) {
  --easy-table-tbody-row: #ffffff;
}
.form-group i {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 22px;
  width: 24px;
  height: 24px;
  font-size: 24px;
  font-weight: bold;
  color: #a3a3a3;
}

.btnAdd {
  width: 156px;
  height: 44px;
  padding: 0;
  flex-shrink: 0;
  border-radius: 8px;
  background-color: #009a78;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  &:hover {
    background-color: #009a78;
    color: #fff;
  }
}
.btn-search {
  display: flex;
  width: 215px;
  height: 44px;
  padding: 8px 13px 8px 45px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border: none;
  border-radius: 5px;
  background: #fff;
  color: #a3a3a3;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  &::placeholder {
    color: #d8d8d8;
    font-style: italic;
  }
  &:focus {
    outline: none;
  }
}
</style>
